import { i18n } from '@lingui/core';
import { Box, Button } from '@warp-ds/react';
import React from 'react';
import { useSearchData } from '../../data/SearchData';
import { SavedSearch } from '../saved-search/SavedSearch';

type SavedSearchTeaserProps = {
    className?: string;
};

export function SavedSearchTeaser(props: SavedSearchTeaserProps) {
    const { className = '' } = props;

    const { numResults, searchData } = useSearchData();

    const hasResults = numResults > 0;
    const isEndOfPaging = searchData?.metadata?.is_end_of_paging;

    if (isEndOfPaging || !hasResults) {
        return null;
    }

    return (
        <SavedSearch>
            {({ isSaveable, isUnsaved, onClick }) =>
                isSaveable && isUnsaved ? (
                    <Box className={`${className} text-center`} info>
                        <h2 className="h4 font-normal">
                            {i18n.t({
                                id: 'results.new-saved-search.heading',
                                message:
                                    'Do you want to be notified when new hits appears in this search?',
                            })}
                        </h2>
                        <div className="my-8">
                            <Button
                                onClick={onClick}
                                link
                                className="font-bold"
                            >
                                {i18n.t({
                                    id: 'results.new-saved-search.button',
                                    message: 'Create saved search',
                                })}
                            </Button>
                        </div>
                    </Box>
                ) : null
            }
        </SavedSearch>
    );
}
